var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMakeItYours(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.385 46.77a23.384 23.384 0 110-46.77 23.384 23.384 0 010 46.77zm10.461-15.878l-9.292-7.138a.37.37 0 00-.579.443l1.736 4.406h-4.05a5.453 5.453 0 01-5.44-5.44v-1.317a5.453 5.453 0 015.44-5.452h10.105v-4.665H21.674a10.117 10.117 0 00-10.117 10.117v1.317A10.117 10.117 0 0021.66 33.268h3.914v.024l.259-.012v.197l-1.859 4.726a.37.37 0 00.579.443l9.292-7.138a.369.369 0 000-.603v-.013z",
    fill: "#000"
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon--make-it-yours-4959a239b50be7908c2e27d9940a5cd0.svg";
export { SvgIconMakeItYours as Component };